// removed by extract-text-webpack-plugin
module.exports = {"FeaturedEvent":"_1rWhojREMpRZ8NCD3Oi7et"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/FeaturedEvent.scss
// module id = 1561
// module chunks = 0